import { PROMO_TEASER_BASE_CLASSNAME } from '@vfde-brix/promo-teaser';
import {
    connect,
    injectSaga,
    injectReducer,
    triggerOverlay,
    eventHelper,
} from '@vfde-fe/sails_core';
import {
    mountHeadline,
    updateHeadline,
    updateSubline,
} from '../../components/mountHeadline';
import mountPromoTeasers from '../../components/mountPromoTeaser';
import {
    mountTradeInPromoTile,
    updatePromoTile,
} from '../../components/mountPromoTile-old';
import { mountSwitch } from '../../components/mountSwitch';
import { NAMESPACE as FNF_NAMESPACE, familyFriendsSaga } from '@vfde-fe/sails-validation';
import {getSaleschannel, getSubscriptionId} from '../Tariff/helper/getSubscriptionDataHelper';
import {
    HARDWARE_ONLY_SWITCH,
    HEADLINE_CONTAINER,
    HORIZONTAL_LIST_CONTAINER,
    OFFER_PRICE_CONTAINER,
    SUBLINE_CONTAINER,
    TECHNICAL_DETAILS_ACCORDION,
} from './constants';
import {
    getHardwareOnly,
    getTradeIn,
} from './helpers/getCustomerConfig';
import { getIsTradeInEligible as deprecatedGetIsTradeInEligible} from './helpers/getIsTradeInEligible';
import './style.scss';
import { RootState } from './types';
import { createStructuredSelector } from 'reselect';
import { mountLoadingSpinner } from '../../components/mountLoadingSpinner';
import {
    createInitialState,
    toggleHardwareOnly,
    toggleInsurance,
    toggleTradeIn,
    goToBasket,
    triggerGigaKombiOverlay,
    triggerTradeInTracking,
    handlePageShow,
} from './actions';
import {
    selectHardwareOnly,
    selectLoading,
    selectName,
    selectInsuranceSelected,
    selectForceRerender,
    selectTradeIn,
    selectOffer,
} from './selectors';
import hardwareDetailReducer from './reducer';
import hardwareDetailSaga from './saga';
import {
    CONTAINER_OPTIONS,
    CONTAINER_MAIN,
    CONTAINER_TARIFF,
    CONTAINER_STORAGE,
} from 'Constant';
import {
    LOADING_INDICATOR_CSS_SELECTOR,
    REDPLUS_KIDS_GROUP,
} from '@vfde-fe/sails-constants';
import optionsReducer from '../Options/reducer';
import tariffReducer from '../Tariff/reducer';
import mountOfferPriceComponents, {
    updateTariffInformation,
    updateDeviceInformation,
} from '../../components/mountOfferPriceComponents';
import {
    selectAtomicId,
    selectCellular,
    selectPrice,
} from '../Options/selectors';
import {
    selectGigakombi,
    selectSalesChannel,
    selectSubscriptionId,
    selectHasSubscription,
    selectIsGigakombiEligible,
} from '../Tariff/selectors';
import { StateProps } from './interface';
import { mountEditorialAccordions } from '../../components/mountAccordion';
import Overlay from '../Overlay';
import mountFeatureTile, {
    updateInsuranceFeatureTile,
} from '../../components/mountFeatureTile';
import { INSURANCE_FEATURE_TILE_CONTAINER } from './constants';
import { handleTradeInOverlayOpen } from '../Overlay/helper/handleTradeInOverlay';
import {
    selectOverlayLoaded,
    selectRootOverlayNameState,
    selectRootOverlayState,
} from '../Overlay/selector';
import { TRADE_IN_OVERLAY_NAME } from '../Overlay/constant';
import tariffSaga from '../Tariff/saga';
import { toggleElement } from '../../helpers/domHelper';
import mountIcon from '../../components/mountIcon';
import {
    storageSaga,
} from '@vfde-fe/sails-storage';
import mountTradeInContainer from '../TradeIn';
import { getIsTradeInEligible } from '../TradeIn/helpers/getIsTradeInEligible';
import {
    disableTradeInSwitch,
    isTradeInSwitchOn,
    setTradeInSwitch,
} from '../TradeIn/helpers/domHelper';
import {
    HARDWARE_TRADEIN,
    HARDWARE_TRADE_IN_HARDWARE_ONLY_NOTIFICATION,
    HARDWARE_TRADE_IN_PROMO_TILE,
    HARDWARE_TRADE_IN_SUMMARY_TILE,
} from '../TradeIn/constants';
import { getTradeInFromTariff } from '../TradeIn/helpers/getCustomerConfig';

function HardwareDetail (state, actions) {
    const {
        createInitialState,
        toggleHardwareOnly,
        toggleInsurance,
        triggerOverlay,
        toggleTradeIn,
        goToBasket,
        handlePageShow,
    } = actions;

    injectReducer(CONTAINER_MAIN, hardwareDetailReducer);
    injectReducer(CONTAINER_OPTIONS, optionsReducer);
    injectReducer(CONTAINER_TARIFF, tariffReducer);

    injectSaga(CONTAINER_MAIN, hardwareDetailSaga);
    injectSaga(CONTAINER_TARIFF, tariffSaga);
    injectSaga(CONTAINER_STORAGE, storageSaga);
    injectSaga(CONTAINER_TARIFF, tariffSaga);
    injectSaga(FNF_NAMESPACE, familyFriendsSaga);

    createInitialState({goToBasket});
    Overlay();

    // We have to mount and update the offer price in the main container because it receives data from both child containers
    const offerPriceContainer = document.getElementById(OFFER_PRICE_CONTAINER);
    const offerPrice = mountOfferPriceComponents(offerPriceContainer);

    // Mount insurance feature tile
    const insuranceTile = mountFeatureTile(INSURANCE_FEATURE_TILE_CONTAINER, (event, isChecked) => toggleInsurance(isChecked, true, false));
    eventHelper(triggerOverlay);
    const loadingSpinner = mountLoadingSpinner(LOADING_INDICATOR_CSS_SELECTOR);
    mountSwitch(HARDWARE_ONLY_SWITCH, toggleHardwareOnly, getHardwareOnly());
    const headline = mountHeadline(HEADLINE_CONTAINER);
    const subline = mountHeadline(SUBLINE_CONTAINER);
    const deprecatedIsTradeInEligible = deprecatedGetIsTradeInEligible(getSaleschannel());
    const tradeInPromoTile = mountTradeInPromoTile(getTradeIn(), getHardwareOnly() || !deprecatedIsTradeInEligible, !deprecatedIsTradeInEligible, toggleTradeIn);
    mountPromoTeasers(PROMO_TEASER_BASE_CLASSNAME);
    // Mount all editorial accordions at once, except hardware-details-accordion, because that is mounted and used by code)
    mountEditorialAccordions([TECHNICAL_DETAILS_ACCORDION]);

    const salesChannel = getSaleschannel();
    const subscriptionId = getSubscriptionId(salesChannel)?.toString();

    if (getIsTradeInEligible(subscriptionId, salesChannel)) {
        // show trade-in elements coming from CMS
        toggleElement(HARDWARE_TRADEIN, false);
        mountTradeInContainer(); // mount trade-in container
    }

    window.addEventListener('pageshow', e => {
        handlePageShow(e);
    });

    return {
        getDerivedStateFromProps (newState: StateProps, oldState: StateProps) {
            const { isHardwareOnly, forceRerender, isTradeIn, salesChannel, subscriptionId, cellular } = newState;

            if (!newState.loading) {
                loadingSpinner.hide();

                if (cellular && cellular !== oldState.cellular) {
                    mountIcon(cellular);
                }

                // Update insurance price
                if ((newState.hasInsurance && forceRerender) || newState.offer.insurance !== oldState.offer.insurance) {
                    updateInsuranceFeatureTile(insuranceTile, newState);

                    if (newState.hasSubscription) {
                        updateTariffInformation(offerPriceContainer, offerPrice, newState, actions);
                    }

                    eventHelper(triggerOverlay);
                }

                // Atomic ID changed, update device name and price
                if (newState.atomicId && newState.atomicId !== oldState.atomicId) {
                    updateTariffInformation(offerPriceContainer, offerPrice, newState, actions); // Need to update tariff information as well for friends and family basket deeplink
                    updateDeviceInformation(offerPrice, newState);
                    updateHeadline(headline, newState.name, isHardwareOnly, salesChannel);
                }

                // Offer changed, update tariff price and information
                if (newState.hasSubscription && newState.hasSubscription !== oldState.hasSubscription) {
                    updateTariffInformation(offerPriceContainer, offerPrice, newState, actions);
                    toggleElement(HORIZONTAL_LIST_CONTAINER, (Number(subscriptionId) === REDPLUS_KIDS_GROUP && !isHardwareOnly));
                    updateSubline(subline, newState);
                }

                // Insurance changed, update monthly price and device name
                if (newState.hasInsurance !== oldState.hasInsurance) {
                    updateDeviceInformation(offerPrice, newState);
                    updateTariffInformation(offerPriceContainer, offerPrice, newState, actions);
                    updateInsuranceFeatureTile(insuranceTile, newState);
                    eventHelper(triggerOverlay);
                }

                // TODO: triggers to often because of isHardwareOnly, find a better way
                if ((null === newState.subscriptionId && !newState.hasInsurance ) || isHardwareOnly) {
                    updateTariffInformation(offerPriceContainer, offerPrice, newState, actions);
                    updateInsuranceFeatureTile(insuranceTile, newState);
                    eventHelper(triggerOverlay);
                }

                if (newState.price && isHardwareOnly !== oldState.isHardwareOnly) {
                    updateTariffInformation(offerPriceContainer, offerPrice, newState, actions);
                    updateDeviceInformation(offerPrice, newState);
                    updateHeadline(headline, newState.name, isHardwareOnly, salesChannel);
                    updateSubline(subline, newState);
                    updateInsuranceFeatureTile(insuranceTile, newState);
                    updatePromoTile(tradeInPromoTile, {checked: isTradeIn, disabled: isHardwareOnly || !deprecatedGetIsTradeInEligible(salesChannel)});
                    toggleElement(HORIZONTAL_LIST_CONTAINER, (Number(subscriptionId) === REDPLUS_KIDS_GROUP && !isHardwareOnly));
                    eventHelper(triggerOverlay);
                }

                // Logic handling trade-in with initial hardware only or when the hardware only state changes
                if (isHardwareOnly || isHardwareOnly !== oldState.isHardwareOnly) {
                    // Disable/enable trade-in switch depending on hardware only state
                    disableTradeInSwitch(isHardwareOnly);

                    if (isHardwareOnly) {
                        // Initial activated hardware only, or hardware only was switched on
                        toggleElement(HARDWARE_TRADE_IN_PROMO_TILE, true);
                        toggleElement(HARDWARE_TRADE_IN_SUMMARY_TILE, true);
                        isTradeInSwitchOn() && toggleElement(HARDWARE_TRADE_IN_HARDWARE_ONLY_NOTIFICATION, false);
                        setTradeInSwitch(false);
                    } else {
                        toggleElement(HARDWARE_TRADE_IN_HARDWARE_ONLY_NOTIFICATION, true);

                        if (getTradeInFromTariff()) {
                            // If hardware only is switched off, and the user previously had a trade-in device selected
                            toggleElement(HARDWARE_TRADE_IN_SUMMARY_TILE, false);
                            setTradeInSwitch(true);
                        }
                    }

                }
            }
            else {
                loadingSpinner.show();
            }

            if (newState.overlayLoaded && newState.overlayLoaded !== oldState.overlayLoaded && newState.overlayName === TRADE_IN_OVERLAY_NAME) {
                handleTradeInOverlayOpen();
            }
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    loading: selectLoading(),
    atomicId: selectAtomicId(),
    name: selectName(),
    price: selectPrice(),
    offer: selectOffer(),
    subscriptionId: selectSubscriptionId(),
    salesChannel: selectSalesChannel(),
    isGigakombi: selectGigakombi(),
    isHardwareOnly: selectHardwareOnly(),
    hasInsurance: selectInsuranceSelected(),
    forceRerender: selectForceRerender(),
    isTradeIn: selectTradeIn(),
    overlayState: selectRootOverlayState(),
    overlayName: selectRootOverlayNameState(),
    overlayLoaded: selectOverlayLoaded(),
    hasSubscription: selectHasSubscription(),
    cellular: selectCellular(),
    isGigakombiEligible: selectIsGigakombiEligible(),
});

const mapDispatch = {
    createInitialState,
    toggleHardwareOnly,
    toggleInsurance,
    triggerOverlay,
    toggleTradeIn,
    goToBasket,
    triggerTradeInTracking,
    triggerGigaKombiOverlay,
    handlePageShow,
};

const mountHardwareDetailContainer = connect(mapStateToProps, mapDispatch)(HardwareDetail);

export default mountHardwareDetailContainer;
